import Logo from "@/components/Logo";
import { useState, useEffect, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function VerifyEmail() {
  const { verifyEmail } = useAuth();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [status, setStatus] = useState(token ? "verifying" : "notoken"); // verifying | success | error | notoken
  const [message, setMessage] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (!token || ran.current) return;
    ran.current = true;
    (async () => {
      try {
        await verifyEmail(token);
        setStatus("success");
      } catch (err) {
        setStatus("error");
        setMessage(err.message);
      }
    })();
  }, [token, verifyEmail]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-[#FAFAFA] flex flex-col">
      <div className="grain" />
      <div className="px-6 lg:px-8 h-20 flex items-center max-w-7xl mx-auto w-full">
        <Link to="/" data-testid="verify-logo" aria-label="MBM home"><Logo className="h-7 w-auto" /></Link>
      </div>
      <div className="flex-1 flex items-center justify-center px-6 pb-20">
        <div className="w-full max-w-md text-center" data-testid="verify-page">
          <div className="section-label text-[10px] text-[#9fd3ff]">Email verification</div>
          {status === "verifying" && (
            <p className="mt-6 text-sm text-zinc-400 font-light animate-pulse" data-testid="verify-loading">Confirming your email…</p>
          )}
          {status === "success" && (
            <>
              <h1 className="mt-4 font-heading text-3xl sm:text-4xl font-light tracking-tight" data-testid="verify-success">Email confirmed.</h1>
              <p className="mt-4 text-sm text-zinc-400 font-light">Your MBM account is now verified. Welcome aboard.</p>
              <Link to="/learn" className="btn-solid mt-8 inline-block px-6 py-3 text-sm font-medium" data-testid="verify-continue">Go to my dashboard</Link>
            </>
          )}
          {(status === "error" || status === "notoken") && (
            <>
              <h1 className="mt-4 font-heading text-3xl sm:text-4xl font-light tracking-tight" data-testid="verify-error">Link invalid.</h1>
              <p className="mt-4 text-sm text-zinc-400 font-light">
                {message || "This verification link is invalid or has expired."} You can request a new one from your dashboard.
              </p>
              <Link to="/login" className="btn-glass text-white mt-8 inline-block px-6 py-3 text-sm font-medium" data-testid="verify-login">Sign in</Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
